// extracted by mini-css-extract-plugin
module.exports = {"root":"XButton-module--root--2InMn"};